import React from "react";
import PropTypes from "prop-types";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

const ErrorAlert = ({
  error,
  onReportFeedbackClick
}) => /*#__PURE__*/React.createElement(Alert, {
  variant: "danger"
}, /*#__PURE__*/React.createElement(Alert.Heading, null, error.name), /*#__PURE__*/React.createElement("p", null, error.message), onReportFeedbackClick && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
  className: "d-flex justify-content-end"
}, /*#__PURE__*/React.createElement(Button, {
  id: "reportBtn",
  onClick: onReportFeedbackClick,
  variant: "outline-danger"
}, "Report feedback"))));

ErrorAlert.propTypes = {
  error: PropTypes.instanceOf(Error),
  onReportFeedbackClick: PropTypes.func
};
export default ErrorAlert;